import styled, { keyframes, css } from "styled-components";
import theme from "../../../../../style/theme";

export const Container = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${p => p.theme.c.blackShadow35};
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    p {
        color: ${p => p.theme.c.dark};
    }
`;

export const Modal = styled.div`
    background-color: ${p => p.theme.c.snow};
    box-shadow: 0 3px 9px ${p => p.theme.c.blackShadow5};
    padding: 20px;
    border-radius: 8px;

    p {
        margin-bottom: -30px;
        font-size: 20px;
        margin-top: 0;
    }

    .button {
        margin-bottom: 0;
        margin-top: -45px;
    }

    ${p =>
        p.theme.xs(css`
            transform: scale(1.8);
        `)}
    ${p =>
        p.theme.sm.only(css`
            transform: scale(1.5);
        `)}
    ${p =>
        p.theme.md.only(css`
            transform: scale(1.2);
        `)}
`;

export const DemoContainer = styled.div`
    width: 256px;
    height: 224px;
    position: relative;
    margin: auto;
`;

const dragAnimation = keyframes`
    0% {
        transform: translate(128px, 128px);
    }
    17% {
        transform: translate(128px, 128px);
    }
    34% {
        transform: translate(128px, 128px);
    }
    51% {
        transform: translate(160px, 96px);
    }
    68% {
        transform: translate(160px, 96px);
    }
    85% {
        transform: translate(128px, 128px);
    }
    100% {
        transform: translate(128px, 128px);
    }
`;

const dragButtonAnimation = (p: { theme: typeof theme}) => keyframes`
    0% {
        background-color: ${p.theme.c.white};
        color: ${p.theme.c.black};
        transform: scale(1);
    }
    17% {
        background-color: ${p.theme.c.active};
        color: ${p.theme.c.white};
        transform: scale(1.1);
    }
    68% {
        background-color: ${p.theme.c.active};
        color: ${p.theme.c.white};
        transform: scale(1.1);
    }
    85% {
        background-color: ${p.theme.c.white};
        color: ${p.theme.c.black};
        transform: scale(1);
    }
    100% {
        background-color: ${p.theme.c.white};
        color: ${p.theme.c.black};
        transform: scale(1);
    }
`;

const dragMarkerAnimation = keyframes`
    0% {
        width: 0;
        visibility: hidden;
    }
    34% {
        width: 0;
        visibility: hidden;
    }

    43% {
        width: 0;
        visibility: hidden;
    }
    44% {
        width: auto;
        visibility: visible;
    }
    68% {
        width: auto;
        visibility: visible;
    }
    69% {
        width: 0;
        visibility: hidden;
    }
    85% {
        width: 0;
        visibility: hidden;
    }
    100% {
        width: 0;
        visibility: hidden;
    }
`;

export const DragSimulator = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    animation: ${dragAnimation} 3s infinite;

    .Button {
        animation: ${p => dragButtonAnimation(p)} 3s infinite;
    }

    .Marker {
        white-space: pre;
        animation: ${dragMarkerAnimation} 3s infinite;
    }
`;
